export default "__VITE_ASSET__W1nm6A7$__"